import Vue          from 'vue';
import VueToast     from 'vue-toast-notification';
import SquareLoader from 'vue-spinner/src/SquareLoader.vue';
import RotateLoader from 'vue-spinner/src/RotateLoader.vue';
import BounceLoader from 'vue-spinner/src/BounceLoader.vue';
import VueTour      from 'vue-tour';
import VueTelInput  from 'vue-tel-input';

import * as Tabs    from './tabs.js';

import 'vue-toast-notification/dist/index.css';
import 'vue-tour/dist/vue-tour.css';

// Components 
import a404 from '@/components/404.vue';

// Mixins
import logger       from '@/lib/logger';
import onboarding   from '@/lib/onboarding'
import currentUser  from '@/lib/state/currentUser';
import * as usageping from '@/lib/usage_ping';


/**
 * The Globals class contains all of the Vue items (components, mixins, methods, etc.) that we include globally throughout the entire Vue app
 */
export class Globals {
    constructor() {
        this.components();
        this.mixins();
        Vue.use(VueToast);
        Vue.use(VueTour);
        Vue.use(Tabs);
        Vue.use(VueTelInput);
    }

    /**
     * Included globally are the following computed values
     * 
     * ### currentUser
     * 
     * Use `mapState` from Vuex to provide `currentUser` to every component.
     */

    /**
     * Included globally are the following components:
     * 
     * * `a-404`: Allow the 404 components to be used anywhere in the app
     */
    components() {
        Vue.component('a-404', a404);
        Vue.component('square-loader', SquareLoader);
        Vue.component('bounce-loader', BounceLoader);
        Vue.component('rotate-loader', RotateLoader);
    }

    /**
     * Included globally are the following Mixins:
     * 
     * ### logger: Allow for DataDog logging from anywhere
     * 
     * This exposes 4 methods throughout the entire app
     * * logInfo
     * * logError
     * * logDebug
     * * logWarn
     * 
     * All for functions take the form
     * 
     * ```javascript
     * logInfo(msg: string, meta: any)
     * ```
     * 
     * Example usage: 
     * ```javascript
     * this.logInfo("Something happened", { method: "saveDeck", foo: "bar" })
     * ```
     * ### currentUser: The current user context
     * 
     * This uses `mapState` from Vuex to share the currentUser with all components. 
     * 
     */
    mixins() {
        Vue.mixin(logger);
        Vue.mixin(onboarding);
        Vue.mixin(currentUser);
        Vue.mixin(usageping.mixin);
    }

}
